import { StyleSheet } from 'react-native';

import maxContainerWidthStyle from '../../../styles/max-container-width/max-container-width.style';
import { mediaQueryValues } from '../../media-query';
import {
  centeredBox,
  extraSmallMarginBottomBox,
  extraSmallPaddingHorizontalOptionButton,
  extraSmallPaddingTopBox,
  extraSmallPaddingVerticalBox,
  mediumPaddingHorizontalBox,
  smallPaddingVerticalBox,
} from '../../view-style';

const mediaQuery = mediaQueryValues();

export default StyleSheet.create({
  container: {
    flex: 1,
    ...maxContainerWidthStyle,
  },
  section: {
    flex: 1,
  },
  image: {
    height: mediaQuery.extraLargeImage,
  },
  view: {
    display: 'flex',
    ...centeredBox,
    ...mediumPaddingHorizontalBox,
    ...smallPaddingVerticalBox,
    ...extraSmallMarginBottomBox,
  },
  text: {
    ...extraSmallMarginBottomBox,
  },
  buttonContent: {
    ...extraSmallPaddingVerticalBox,
  },
  buttonContainer: {
    marginHorizontal: 'auto',
    width: '100%',
    maxWidth: 400,
  },
  inputContainer: {
    marginHorizontal: 'auto',
    width: '100%',
    maxWidth: 400,
  },
  hint: {
    ...centeredBox,
    flexDirection: 'row',
    ...extraSmallPaddingTopBox,
  },
  hintText: {
    ...extraSmallPaddingHorizontalOptionButton,
  },
});
